import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs';
import { ApiUrl } from '../constants/api-url';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {
  private httpClient = inject(HttpClient);

  constructor() { }

  getAllUserRead(orgUniqueId: string) {
    return this.httpClient.get(`${ApiUrl.GET_ALL_USER_READ}` + orgUniqueId).pipe(
      catchError((error) => {
        return error;
      })
    );
  }

  getAllRoleDefinitions() {
    return this.httpClient.get(`${ApiUrl.GET_ALL_ROLEDEFINITIONS_READ}`).pipe(
      catchError((error) => {
        return error;
      })
    );
  }

  getUserRoleInformation(uniqueID: string) {
    return this.httpClient.get(`${ApiUrl.GET_USER_ROLE_INFO}` + uniqueID).pipe(
      catchError((error) => {
        return error;
      })
    );
  }

  updateUserRole(userUniqueId:string,userStatus:any,roles: string[]) {
    return this.httpClient.post(`${ApiUrl.UPDATE_BUYER_USER_ROLE}UserUniqueID=${userUniqueId}&Status=${userStatus}`, roles).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  getRolePermission(roleUniqueID: string) {
    return this.httpClient.get(`${ApiUrl.GET_ROLE_PERMISSION}` + roleUniqueID).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  getOrganizationByName(searchString: string) {
    return this.httpClient.get(`${ApiUrl.GET_ORGANIZATION_BY_NAME}`+ searchString).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  getPermissionByAudience(audience: string) {
    return this.httpClient.get(`${ApiUrl.GET_PERMISSION_BY_AUDIENCE}`+ audience).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  updateRolePermission(operation: string, data: any) {
    return this.httpClient.post(`${ApiUrl.UPDATE_ROLE_PERMISSION}${operation}`, data).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  addRolePermission(data: any) {
    return this.httpClient.post(`${ApiUrl.ADD_ROLE_PERMISSION}`, data).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
  getUserProfile(userUniqueID: string) {
    return this.httpClient.get(`${ApiUrl.GET_USER_PROFILE}` + userUniqueID).pipe(
      catchError((error) => {
        return error;
      })
    );
  }
}
